import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { AccountOpeningV2AccountAgreementStepLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const AccountOpeningV2AccountAgreementStepTemplate = ({ resource }) => {
  const { setPageContentCollection, loadPageContentLink } = usePageContentContext();
  return (
    <WorkflowLayout appearance="elevated" resource={resource}>
      <FDContentContainer maxWidth="sm">
        <MetaResourceRenderer
          metaOverrideSet={metaOverrideSet}
          layout={AccountOpeningV2AccountAgreementStepLayout}
          LayoutProps={{ navigateToLink: loadPageContentLink }}
          resource={resource}
          onSubmit={setPageContentCollection}
        />
      </FDContentContainer>
    </WorkflowLayout>
  );
};

AccountOpeningV2AccountAgreementStepTemplate.defaultProps = {
};

AccountOpeningV2AccountAgreementStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
